import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var generateBreakpoints = breakpoints => {
  if (!(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.sm)) {
    Object.assign(breakpoints, {
      xs: {
        slidesToScroll: 1,
        slidesPerPage: 1,
        seekGap: 0,
        itemSpacing: 0
      }
    });
  }
  if (!(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.sm)) breakpoints.sm = Object.assign({}, breakpoints.xs);
  if (!(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.md)) breakpoints.md = Object.assign({}, breakpoints.sm);
  if (!(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.lg)) breakpoints.lg = Object.assign({}, breakpoints.md);
  if (!(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.xl)) breakpoints.xl = Object.assign({}, breakpoints.lg);
  return breakpoints;
};
export var getCarouselWidgetStyles = (props, isLargeScreen, heightConfig) => {
  var backgroundColor = props.backgroundColor,
    _props$alignment = props.alignment,
    alignment = _props$alignment === void 0 ? 'left' : _props$alignment,
    _props$navigationCtaP = props.navigationCtaPosition,
    navigationCtaPosition = _props$navigationCtaP === void 0 ? 'absolute' : _props$navigationCtaP,
    indicatorBottomPosition = props.indicatorBottomPosition,
    aspectRatio = props.aspectRatio;
  return StyleSheet.create({
    container: {
      position: 'relative',
      backgroundColor: backgroundColor
    },
    imageSlide: Object.assign(Object.assign({
      width: '100%'
    }, aspectRatio ? {
      aspectRatio
    } : heightConfig && {
      minHeight: isLargeScreen ? heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.desktop : heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.mobile
    }), {
      resizeMode: 'cover'
    }),
    navigationCtaContainer: {
      position: navigationCtaPosition ? navigationCtaPosition : 'absolute',
      bottom: indicatorBottomPosition ? indicatorBottomPosition : tokens.spacing.SPACING_12,
      paddingLeft: tokens.spacing.SPACING_20,
      width: '100%'
    },
    navigationCtaInnerContainer: {
      alignItems: 'center',
      justifyContent: alignment === 'center' ? 'center' : 'flex-start'
    },
    navigationSlideCounter: {
      marginHorizontal: isLargeScreen ? 41 : 34.5
    }
  });
};